export const fetch_customer_details_api = "eud/auth/customer/details";
export const update_customer_avatar_api = "eud/auth/update/customer/avatar";
